module.exports = __webpack_public_path__ + "img/12-half-sm.2ec99f20.jpg";